"use strict"

import React, { useState } from "react"

import { withPlotSettingsConfig } from "../../../config/PlotSettingsConfigProvider"

function AnnotationLayerComment({
  x,
  panelHeight,
  marker,
  timeExtractor, // From PlotSettingsConfigProvider
}) {
  const [isVisible, setIsVisible] = useState(true)
  const time = timeExtractor.name === "Day" ? marker.day : marker.timestamp

  const handleAnnotationClick = () => {
    setIsVisible(() => !isVisible)
  }
  return (
    <>
      {isVisible && (
        <foreignObject x={x(time)} y={"0"} width={panelHeight} height={panelHeight}>
          <div className={"annotation-text"} onClick={handleAnnotationClick}>
            {marker.comment}
          </div>
        </foreignObject>
      )}
    </>
  )
}

export default withPlotSettingsConfig(AnnotationLayerComment)
